<template>
  <v-container v-if="this.$store.getters.programsFetched">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title xs12 sm6>
            <div v-if="showEmail">
              <h1 class="block-header">{{ $t('message.register.welcome') }}</h1>
              <v-divider></v-divider>
              <p
                class="block-message"
                v-html="i18n('message.register.welcomeMessage', { programName: this.$store.getters.getProgramDisplayName })"
              ></p>
            </div>
            <div v-if="!showEmail">
              <h1 class="block-header">
                {{ $t('message.register.emailSent') }}
              </h1>
              <v-divider></v-divider>
              <p
                class="block-message"
                v-html="
                  $t('message.register.emailMessage', { email: this.email })
                "
              ></p>
              <p
                class="block-message"
                v-html="$t('message.register.resendMessage')"
              ></p>
            </div>
            <v-flex sm8 offset-sm2>
              <v-form
                v-model="valid"
                v-if="showEmail"
                ref="form"
                lazy-validation
              >
                <v-text-field
                  label="E-mail"
                  v-model="email"
                  type="email"
                  :rules="emailRules"
                  validate-on-blur
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-card-title>
          <v-layout justify-center>
            <v-card-actions class="button-buffer">
              <v-btn
                block
                class="btn-primary ie-large-btn"
                v-show="showEmail"
                @click="submit()"
                :disabled="!valid"
                >{{ $t('message.register.register') }}</v-btn
              >
              <v-btn
                block
                class="btn-primary ie-medium-btn"
                v-show="!showEmail"
                @click="reenter()"
                >{{ $t('message.reenter') }}</v-btn
              >
              <v-btn
                block
                class="btn-primary"
                v-show="!showEmail"
                @click="submit(true)"
                >{{ $t('message.resend') }}</v-btn
              >
            </v-card-actions>
            <v-card-actions class="button-buffer">
              <router-link to="/">{{ $t('message.login.login') }}</router-link>
              <router-view></router-view>
            </v-card-actions>
          </v-layout>

          <v-layout justify-center>
            {{$t('message.supportNumberMsg')}}
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    valid: true,
    showEmail: true,
    loggedIn: false,
    email: '',
    password: ''
  }),
  methods: {
    reenter() {
      this.email = ''
      this.showEmail = true
    },
    submit(resent) {
      if (!this.showEmail || this.$refs.form.validate()) {
        axios
          .post('api/v1/pub/participant/requestAccount', {
            email: this.email,
            domain: this.$store.getters.getProgram.domain,
            providerSalesrep: this.$cookie.get('tdc_ref_code')
          })
          .then(response => {
            if (resent) {
              this.notifyInfo('Email sent')
            }
            this.showEmail = false
          })
          .catch(error => {
            this.notifyAxiosError(error, 'Error registering new account')
            this.showEmail = true
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue